import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';
import CustomTooltipModelNameElement from '../common/CustomTooltipModelNameElement';

/**
 * MainGridMiddleLeftRowDayOnTypeSlot
 */
class MainGridMiddleLeftRowDayOnTypeSlot extends React.Component {

  render() {
    const { dataDayOnItem, toK015Param, index } = this.props;

    // URLパラメータを取得する。
    const contextparamList = [];
    contextparamList.push('ps=' + toK015Param.pskubun); // パチンコ・スロット
    contextparamList.push('machineId=' + dataDayOnItem.kishuid); // 機種ID
    contextparamList.push('kikanUnit=' + toK015Param.kikanUnit); // 期間タブ
    contextparamList.push('term=' + toK015Param.term); // 期間

    // シン機種画面のURLパラメータを設定する。
    const toK015URL = commonLogic.getUrlParam(contextparamList);

    const newFlag = this.props.dataDayOnItem.newFlag;
    const modelName = dataDayOnItem.kishumei;
    const brandName = dataDayOnItem.koumoku16;
    const kisyuNameElement = <CustomTooltipModelNameElement targetLink={toK015URL} modelName={modelName} brandName={brandName} />;

    if (newFlag == 1) {
      return (
        <div className="rowl1" name="col_kubun" id="col_kubun">
          <div className="coll1 ib vm textcenter col_koumoku_number no_extend except_highlight">
            <p className="nh ">
              {index + 1}
            </p>
          </div>
          <div className="coll2 ib vm border_r col_kishu no_extend except_highlight">
            <div className="kishu_container">
              <div className="kishu_name">
                {kisyuNameElement}
              </div>
              <div className="new_icon">
                <span className="new_label">NEW</span>
              </div>
            </div>
          </div>
          <div className="col1 ib vm col_day border_r no_extend except_highlight textcenter border_left">
            <p className="nh border_bottom">平日</p>
            <p className="nh border_bottom">休日</p>
            <p className="nh">期間</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="rowl1" name="col_kubun" id="col_kubun">
          <div className="coll1 ib vm textcenter col_koumoku_number no_extend except_highlight">
            <p className="nh ">
              {index + 1}
            </p>
          </div>
          <div className="coll2 ib vm border_r col_kishu no_extend except_highlight">
            <div className="kishu_name">
              {kisyuNameElement}
            </div>
          </div>
          <div className="col1 ib vm col_day border_r no_extend except_highlight textcenter border_left">
            <p className="nh border_bottom">平日</p>
            <p className="nh border_bottom">休日</p>
            <p className="nh">期間</p>
          </div>
        </div>
      );
    }
  }
}

MainGridMiddleLeftRowDayOnTypeSlot.propTypes = {
  dataDayOnItem: PropTypes.any.isRequired,
  toK015Param: PropTypes.any.isRequired,
};

export default MainGridMiddleLeftRowDayOnTypeSlot;
